import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LgvClientService, LgvUserService } from '../../../../core/core.module';
import { BehaviorSubject, first } from 'rxjs';
import { ConfirmationDialogComponent } from '../../../../shared/confirmation-dialog/confirmation-dialog.component';
import { Router } from '@angular/router';

@Component({
    selector: 'lgv-edit-scenario-modal',
    templateUrl: './edit-scenario-modal.component.html',
    styleUrls: ['./edit-scenario-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditScenarioModalComponent implements OnInit {
    scenarioForm: UntypedFormGroup;
    isLoading$ = new BehaviorSubject(false);
    constructor(public dialogRef: MatDialogRef<EditScenarioModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: FormBuilder,
        private lgvclientSvc: LgvClientService,
        private lgvUserSvc: LgvUserService,
        private matDialog: MatDialog,
        private router: Router) { }

    ngOnInit(): void {
        this.scenarioForm = this.fb.group({
            name: [this.data?.scenario?.name],
            notes: [this.data?.scenario?.notes],
        })
    }

    saveChanges() {
        if (this.lgvUserSvc.isPreLicensedAgent) {
            this.lgvUserSvc.showPreLicensingModal();
        } else {
            this.isLoading$.next(true);
            const scenario = this.data?.scenario;
            scenario.name = this.scenarioForm?.controls['name'].value
            scenario.notes = this.scenarioForm?.controls['notes'].value;
            // save only if there is a previous saved scenario. for new scenario it will be saved on POST
            if (scenario?.id) {
                this.lgvclientSvc.updateScenario(this.data?.scenario?.id, scenario).pipe(first()).subscribe((response) => {
                    this.isLoading$.next(false);
                    this.dialogRef.close({
                        name: scenario.name,
                        notes: scenario.notes
                    });
                });
            } else {
                this.isLoading$.next(false);
                this.dialogRef.close({
                    name: scenario.name,
                    notes: scenario.notes
                });
            }
        }       
    }

}
